import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodCard } from "../../../../Components/PaymentMethodCard/PaymentMethodCard";
import messages from "./messages";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

interface Props {
  onClick: (paymentMethod: string) => void;
  disabled?: boolean;
}

export const PayPalPaymentCard: FC<Props> = ({ onClick, disabled }) => {
  return (
    <PaymentMethodCard
      title={<FormattedMessage {...messages.paypal} />}
      onClick={onClick}
      cardNetworkIcons={["paypal"]}
      value={PaymentMethodType.PAYPAL}
      disabled={disabled}
      data-testid="paypal-payment-link"
      disabledModalTitle={<FormattedMessage {...messages.noPaypal} />}
      disabledModalContent={
        <FormattedMessage
          {...messages.paypalTransactionsAreNotSupportedForThisService}
        />
      }
    />
  );
};
